import { StyleSheet, Image } from "react-native";
import React from "react";
import { VStack, Box, Text, HStack } from "native-base";
import AutoScroll from "./AutoScroll";
import { LinearGradient } from "expo-linear-gradient";

type BottomSlidingImagesProps = {
  partners: { image: any; name: string; color?: string }[];
};

const BottomSlidingImages = (props: BottomSlidingImagesProps) => {
  const partners = props?.partners;

  const renderItem = ({
    item,
    index,
  }: {
    item: { image: any; name: string; color?: string };
    index: number;
  }) => (
    <VStack key={item.name}>
      <Box
        borderRadius={12}
        bg={item?.color || "#fff"}
        justifyContent="center"
        style={{ height: 50 }}
      >
        <Image
          source={item.image}
          style={{
            width: 80,
            height: 40,
            borderRadius: 10,
            alignSelf: "center",
          }}
          resizeMode="contain"
        />
      </Box>

      <LinearGradient
        colors={[
          "transparent",
          "transparent",
          "transparent",
          "transparent",
          "rgba(0,0,0,0.1)",
          "rgba(0,0,0,0.1)",
          "rgba(0,0,0,0.1)",
        ]}
      >
        <Text textAlign="center" textTransform={"uppercase"} fontWeight="bold">
          {item.name}
        </Text>
      </LinearGradient>
    </VStack>
  );

  return (
    <AutoScroll>
      <HStack py={5} space={4}>
        {partners.map((item, index) => renderItem({ item, index }))}
      </HStack>
    </AutoScroll>
  );
};

export default BottomSlidingImages;

const styles = StyleSheet.create({
  shadow: {
    shadowOffset: { width: 0, height: 5 },
    shadowRadius: 5,
    shadowOpacity: 0.3,
    shadowColor: "#000000",
    elevation: 20,
  },
});
